export let razorpayKey;

if (process.env.NODE_ENV === 'production') {
  razorpayKey = 'rzp_live_EFUTrKaUbzD7uD';
} else {
  razorpayKey = 'rzp_test_GgcYUzjZKPkPtK';
}
